import { NegativeFill } from 'ui/icons';
import { AppAndBrowser } from 'ui/icons/devices/AppAndBrowser';
import { TV } from 'ui/icons/devices/TV';
import { colors } from 'ui/theme';
import { TargetCheckbox } from './TargetCheckbox';
import {
  TargetContentContainer,
  TextContainer,
  HeaderText,
  BodyText,
  ErrorCaption,
} from './DestinationSelectorModal.styled';
import { useDestinationSelector } from './useDestinationSelector';
import {
  getRokuBodyText,
  getAppAndBrowserBodyText,
  DESTINATION_SELECTOR_MODAL_CONTENT,
} from './DestinationSelectorModal.utils';
import { useDestinationAppsAndWebsites } from './useDestinationAppsAndWebsites';

export const DestinationSelectorContent = () => {
  const {
    appAndBrowserSelected,
    handleAppAndBrowserClick,
    rokuSelected,
    handleRokuClick,
    unsetError,
  } = useDestinationSelector();

  const { mobileAppsAndWebsites, rokuApps } = useDestinationAppsAndWebsites();

  const rokuBodyText = getRokuBodyText(rokuApps);
  const appAndBrowserBodyText = getAppAndBrowserBodyText(mobileAppsAndWebsites);

  return (
    <>
      <TargetCheckbox
        id="app-and-browser"
        onClick={handleAppAndBrowserClick}
        selected={appAndBrowserSelected}
        hasError={unsetError}
      >
        <TargetContentContainer>
          <AppAndBrowser />
          <TextContainer>
            <HeaderText>{DESTINATION_SELECTOR_MODAL_CONTENT.appAndBrowser.title}</HeaderText>
            <BodyText>{appAndBrowserBodyText}</BodyText>
          </TextContainer>
        </TargetContentContainer>
      </TargetCheckbox>

      <TargetCheckbox
        id="roku"
        onClick={handleRokuClick}
        selected={rokuSelected}
        hasError={unsetError}
      >
        <TargetContentContainer>
          <TV />
          <TextContainer>
            <HeaderText>{DESTINATION_SELECTOR_MODAL_CONTENT.roku.title}</HeaderText>
            <BodyText>{rokuBodyText}</BodyText>
          </TextContainer>
        </TargetContentContainer>
      </TargetCheckbox>

      {unsetError && (
        <ErrorCaption>
          <NegativeFill color={colors.red100} />
          {DESTINATION_SELECTOR_MODAL_CONTENT.errors.unset}
        </ErrorCaption>
      )}
    </>
  );
};
